import React, { Component } from "react";
import parsePhoneNumber from "libphonenumber-js";

import helpers from "../../helpers";

const moment = require("moment");

const currency_symbols = {
  USD: "$", // US Dollar
  ILS: "₪", // Israeli New Sheqel
};

const cards = require.context("../../assets/img/payment/light", true);

export default class Wallet extends Component {
  constructor(props) {
    super(props);
    this.state = {
      app: props.app,
      jobs: [],
      loading: true,
    };

    this.removeCard = this.removeCard.bind(this);
  }

  async componentDidMount() {
    const response = await helpers.serviceRequest("getJobs", {
      clients: [this.state.app.state.userRef.id],
      offset: 0,
      limit: 10000,
    });
    this.setState({ jobs: response, loading: false });
  }

  removeCard() {
    this.state.app.state.userRef.update({ payment: null });
  }

  render() {
    const client = this.state.app.state.client;

    const phoneNumber = parsePhoneNumber(client.phone);

    let card, cardPreview, amount, currency;

    if (!client.balance || !client.balance.amount) {
      amount = 0;
      currency = "ILS";
    } else {
      amount = Number(client.balance.amount).toFixed(2);
      currency = client.balance.currency;
    }

    try {
      card = client.payment.details;
    } catch (e) {}

    if (card) {
      switch (card.brand.toLowerCase()) {
        case "diners club":
          card.img = cards("./diners-club.png");
          break;
        case "discover":
          card.img = cards("./discover.png");
          break;
        case "mastercard":
          card.img = cards("./mastercard.png");
          break;
        case "visa":
          card.img = cards("./visa.png");
          break;
        case "american express":
          card.img = cards("./american-express.png");
          break;
        case "isracard":
          card.img = cards("./isracard.png");
          break;
      }
      cardPreview = (
        <div className="card-preview">
          <div style={{ display: "flex" }}>
            <img src={card.img} />
            <span className="details">
              {card.brand} {card.last4}
            </span>
          </div>
          <div>
            <i className="far fa-lg fa-trash-alt" onClick={this.removeCard}></i>
          </div>
        </div>
      );
    } else {
      cardPreview = <div className="card-preview">No card</div>;
    }

    const { jobs, loading } = this.state;
    let listJobs;
    if (loading)
      listJobs = (
        <div className="loader">
          <i className="fal fa-circle-notch fa-spin"></i> Loading...
        </div>
      );
    else {
      listJobs = jobs.map((job) => {
        let currency_symbol;
        switch (job.cost_currency) {
          case "ils":
            currency_symbol = "₪";
            break;
          case "usd":
            currency_symbol = "$";
            break;
        }
        let icon;
        let action;
        switch (job.action) {
          case "print":
            icon = "fa-print";
            action = "print";
            break;
          case "copy":
            icon = "fa-clone";
            action = "copy";
            break;
          case "scan":
            icon = "fa-scanner-image";
            action = "scan";
            break;
        }
        return (
          <a key={job.id} href="#">
            <i className={`fal ${icon} color-blue1-dark`}></i>
            <span>{action}</span>
            <em className="job-pages">
              <i className="fal fa-clone" style={{ lineHeight: 20 + "px" }}></i>
              {job.pages * job.copies}
            </em>
            <em className="bg-blue1-light font-11">
              {currency_symbol} {Number(job.cost_amount).toFixed(2)}
            </em>
            <strong>{moment(job.time).format("DD/MM/YYYY HH:mm")}</strong>
          </a>
        );
      });
    }

    return (
      <div id="page">
        <div className="header header-fixed header-logo-app no-shadow">
          <a href="#" className="header-title ultrabold">
            Wallet
          </a>
          <div
            className="header-icon header-icon-1"
            onClick={() => this.state.app.change("main")}
          >
            <i className="far fa-arrow-left"></i>
          </div>
        </div>
        <div
          className="page-content header-clear page-payment"
          style={{ paddingTop: 95 + "px" }}
        >
          <div className="box">
            <p className="boxed-text-huge opacity-90 color-highlight font-18 bottom-5">
              {phoneNumber.formatNational()}
            </p>
            <h1 className="center-text color-theme bolder font-40">
              {currency_symbols[currency.toUpperCase()]} {amount}
            </h1>
            <p className="boxed-text-huge color-theme opacity-90 color-highlight font-14 bottom-20">
              Current balance
            </p>
            <div className="divider bottom-0"></div>
            {cardPreview}
            <div className="divider top-0 bottom-10"></div>
          </div>

          <div className="content link-list link-list-2 link-list-long-border touchmove">
            {listJobs}
          </div>
        </div>
        <div className="menu-hider"></div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/wallet.js